// extracted by mini-css-extract-plugin
module.exports =  {"attributes-tooltip-wrapper":"jMOok_7","attributesTooltipWrapper":"jMOok_7","attribute-item":"kr2gB2x","attributeItem":"kr2gB2x"};